import { environment } from './../../environments/environment';
import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient, private dataservice: DataService,private router: Router,
    private toastService: ToastService) { }

  private handleError<T>(operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {
      return of(result as T);
    };
  }

  postAPI(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .post<any[]>(environment.baseUrl + endPoint, payload, {
        headers: { "Content-Type": "application/json", Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  postAPIV2(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .post<any[]>(environment.baseUrlV2 + endPoint, payload, {
        headers: { "Content-Type": "application/json", Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  postAPIV3(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .post<any[]>(environment.baseUrlV3 + endPoint, payload, {
        headers: { "Content-Type": "application/json", Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  postAPI_newEpisode(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .post<any[]>(environment.baseUrlV2 + endPoint, payload, {
        headers: { Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  postAPI_newEpisodeV3(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .post<any[]>(environment.baseUrlV3 + endPoint, payload, {
        headers: { Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  postAPIAuth(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .post<any[]>(environment.baseUrl + endPoint, payload, {
        headers: { Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  postAPIAuthV3(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .post<any[]>(environment.baseUrlV3 + endPoint, payload, {
        headers: { Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  getAPI(endPoint): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .get<any[]>(environment.baseUrl + endPoint, {
        headers: { 'Content-Type': 'application/json', Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  getAPIV2(endPoint): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .get<any[]>(environment.baseUrlV2 + endPoint, {
        headers: { 'Content-Type': 'application/json', Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  getAPIV3(endPoint): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .get<any[]>(environment.baseUrlV3 + endPoint, {
        headers: { 'Content-Type': 'application/json', Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  putAPI(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .put<any[]>(environment.baseUrl + endPoint, payload, {
        headers: { 'Content-Type': 'application/json', Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  putAPIV2(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .put<any[]>(environment.baseUrlV2 + endPoint, payload, {
        headers: { 'Content-Type': 'application/json', Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }

  putAPIV3(endPoint, payload): Observable<any[]> {
    const token = this.dataservice.getUserToken()
      ? this.dataservice.getUserToken()
      : '';
    return this.http
      .put<any[]>(environment.baseUrlV3 + endPoint, payload, {
        headers: { 'Content-Type': 'application/json', Auth: token },
      })
      .pipe(
        tap((result) => {
          let response = this.generateResponse(result);
        }),
        catchError(this.handleError('Response', []))
      );
  }
 
  generateResponse(response) {
    if (response.statusCode == 200) {
      return response;
    }
    else if (response.statusCode == 401) {
      this.dataservice.logoutUser();
    }else if(response.message == 'Please send token'){
      this.dataservice.logoutUser();
    } else {
      return response;
    }
  }

deleteAPI(endPoint): Observable<any[]> {
  const token = this.dataservice.getUserToken()
    ? this.dataservice.getUserToken()
    : '';
  return this.http
    .delete<any[]>(environment.baseUrl + endPoint, {
      headers: { 'Content-Type': 'application/json', Auth: token },
    })
    .pipe(
      tap((result) => {
        let response = this.generateResponse(result);
      }),
      catchError(this.handleError('Response', []))
    );
}

deleteAPIV2(endPoint): Observable<any[]> {
  const token = this.dataservice.getUserToken()
    ? this.dataservice.getUserToken()
    : '';
  return this.http
    .delete<any[]>(environment.baseUrlV2 + endPoint, {
      headers: { 'Content-Type': 'application/json', Auth: token },
    })
    .pipe(
      tap((result) => {
        let response = this.generateResponse(result);
      }),
      catchError(this.handleError('Response', []))
    );
}

deleteAPIV3(endPoint): Observable<any[]> {
  const token = this.dataservice.getUserToken()
    ? this.dataservice.getUserToken()
    : '';
  return this.http
    .delete<any[]>(environment.baseUrlV3 + endPoint, {
      headers: { 'Content-Type': 'application/json', Auth: token },
    })
    .pipe(
      tap((result) => {
        let response = this.generateResponse(result);
      }),
      catchError(this.handleError('Response', []))
    );
}

  getData(endPoint, payload){
    const token = this.dataservice.getUserToken()
    ? this.dataservice.getUserToken()
    : '';
    return this.http.post(environment.baseUrl+endPoint,payload, {
      headers: { "Content-Type": "application/json", Auth: token },
    })
    .toPromise()
    .then(response => response)
    .catch(this.handleError);
  }
}

